import {AssetFactItem} from './AssetFactItem';

import type {AssetFact} from './asset-header.utils';
import type {FC} from 'react';

export interface AssetFactsListProps {
  facts: AssetFact[];
}

/** overflow-hidden clips the leading rule off whichever item wraps — it lands outside. */
export const AssetFactsList: FC<AssetFactsListProps> = ({facts}) => (
  <dl className="flex flex-wrap items-baseline gap-x-4 gap-y-1 overflow-hidden tabular-nums">
    {facts.map((fact, index) => (
      <AssetFactItem key={fact.key} fact={fact} isFirst={index === 0} />
    ))}
  </dl>
);
